import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import Select from 'react-select';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { header } from '../../../components/header.encry';

function Catalog() {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [products, setProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [search, setSearch] = useState('');

  // Cache for products by category and images by product id
  const productCache = useRef({});
  const imageCache = useRef({});

  useEffect(() => {
    const token = sessionStorage.getItem('token');
    if (!token) return;
    axios
      .get(`${process.env.REACT_APP_PEGASUS_API_URL}/doli/categories/${token}`, header())
      .then(res => {

        const data = res.data?.data || [];
        setCategories(data.map(c => ({ value: c.id, label: c.label })));
        console.log(categories);
      })
      .catch(err => console.error('categories', err));
  }, []);

  useEffect(() => {
    if (!selectedCategory) return;
    const cached = productCache.current[selectedCategory.value];
    if (cached) {
      setProducts(cached);
      return;
    }
    const token = sessionStorage.getItem('token');
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_PEGASUS_API_URL}/doli/products/${selectedCategory.value}/${token}`,
          header()
        );
        const baseProducts = res.data?.products || [];

        const variantArrays = await Promise.all(
          baseProducts.map(async p => {
            try {
              const vRes = await axios.get(
                `${process.env.REACT_APP_PEGASUS_API_URL}/doli/products/${p.id || p.rowid}/variants/${token}`,
                header()
              );
              const variants = vRes.data?.data || [];

              const children = await Promise.all(
                variants.map(async v => {
                  try {
                    if (v.child) {
                      return { ...v.child, parentId: p.id || p.rowid, variantId: v.id };
                    }
                    const childRes = await axios.get(
                      `${process.env.REACT_APP_PEGASUS_API_URL}/doli/product/${v.fk_product_child}/${token}`,
                      header()
                    );
                    const child = childRes.data?.data;
                    return child ? { ...child, parentId: p.id || p.rowid, variantId: v.id } : null;
                  } catch (err) {
                    console.error('variant child', err);
                    return null;
                  }
                })
              );

              return children.filter(Boolean);
            } catch (e) {
              console.error('variants', e);
              return [];
            }
          })
        );

        const variantProducts = variantArrays.flat();
        const allProds = [...baseProducts, ...variantProducts];
        setProducts(allProds);
        productCache.current[selectedCategory.value] = allProds;
      } catch (err) {
        console.error('products', err);
      }
    };

    fetchData();
  }, [selectedCategory]);

  const filteredProducts = products.filter(p =>
  (!search ||
    (p.ref && p.ref.toLowerCase().includes(search.toLowerCase())) ||
    (p.label && p.label.toLowerCase().includes(search.toLowerCase())))
  );

  const productOptions = filteredProducts.map(p => ({ value: p.ref, label: `${p.ref} - ${p.label}`, data: p }));

  const fetchImage = async (id) => {
    if (imageCache.current[id]) return imageCache.current[id];
    const token = sessionStorage.getItem('token');
    if (!id || !token) return null;
    try {
      const res = await axios.get(`${process.env.REACT_APP_PEGASUS_API_URL}/doli/product-file/${id}/${token}`, {
        ...header()
      });
      const img = res.data.base64; // base64 directement prêt pour <img src="..." />
      imageCache.current[id] = img;
      return img;
    } catch (e) {
      console.error('image', e);
      return null;
    }
  };
const handleProductChange = items => {
  if (!items) {
    setSelectedOptions([]);
    setSelectedProducts([]);
    return;
  }
  setSelectedOptions(items);
  const prods = items.map(opt => {
    const id = opt.data.id || opt.data.rowid;
    // Prefer cache, then opt.data.imageUrl
    const img = imageCache.current[id] || opt.data.imageUrl;
    return { ...opt.data, imageUrl: img, discount: 0 };
  });
  setSelectedProducts(prods);

  // Only fetch if image is missing (not in cache, not in opt.data)
  prods.forEach(async (prod, idx) => {
    if (!prod.imageUrl) {
      const id = prod.id || prod.rowid;
      // Double check cache before fetching, in case parallel fetches
      if (!imageCache.current[id]) {
        const img = await fetchImage(id);
        setSelectedProducts(prev => {
          const updated = [...prev];
          if (updated[idx]) updated[idx] = { ...updated[idx], imageUrl: img };
          return updated;
        });
      }
    }
  });
};


  const handleDiscountChange = (index, value) => {
    setSelectedProducts(prev => prev.map((p, i) => i === index ? { ...p, discount: value } : p));
  };

  const handleRemoveProduct = (index) => {
    setSelectedProducts(prev => prev.filter((_, i) => i !== index));
    setSelectedOptions(prev => prev.filter((_, i) => i !== index));
  };


const exportExcel = async () => {
  const includeStock = window.confirm('Inclure le stock r\u00e9el dans le fichier Excel ?');
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Produits');

  const cols = [
    { header: 'Image', key: 'img', width: 15 }, // width in chars; image size is defined below
    { header: 'Ref', key: 'ref', width: 15 },
    { header: 'Nom', key: 'nom', width: 30 },
    { header: 'Prix TTC', key: 'price', width: 15 },
    { header: 'Remise (%)', key: 'discount', width: 15 },
    { header: 'Prix Remisé', key: 'discountedPrice', width: 15 }
  ];
  if (includeStock) cols.push({ header: 'Stock R\u00e9el', key: 'stock', width: 15 });
  worksheet.columns = cols;

  for (const p of selectedProducts) {
    const rowValues = {
      ref: p.ref,
      nom: p.label,
      price: Number(p.price_ttc || 0).toFixed(2),
      discount: p.discount || 0,
      discountedPrice: Number(p.price_ttc * (1 - (p.discount || 0) / 100)).toFixed(2)
    };
    if (includeStock) rowValues.stock = p.stock_reel;
    const row = worksheet.addRow(rowValues);

    if (p.imageUrl) {
      try {
        const imgRes = await axios.get(p.imageUrl, { responseType: 'arraybuffer' });
        const imageId = workbook.addImage({ buffer: imgRes.data, extension: 'jpeg' });
        worksheet.addImage(imageId, {
          tl: { col: 0, row: row.number - 1 },
          ext: { width: 100, height: 100 }
        });
        row.height = 100;
      } catch (e) {
        console.error('excel image', e);
      }
    }
  }

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), 'catalog.xlsx');
};

  return (
    <div className="container mt-4">
      <div className="mb-3">
        <label>Catégories</label>
        <Select options={categories} onChange={setSelectedCategory} value={selectedCategory} />
      </div>
      {selectedCategory && (
        <>
          <div className="mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Recherche par ref ou nom"
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </div>
          <div className="mb-3">
            <label>Produits</label>
            <Select
              isMulti
              options={productOptions}
              onChange={handleProductChange}
              closeMenuOnSelect={false}
              value={selectedOptions}
            />
          </div>
          {selectedProducts.length > 0 && (
            <>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Image</th>
                    <th>Ref</th>
                    <th>Nom</th>
                    <th>Prix TTC</th>
                    <th>Remise (%)</th>
                    <th>Prix Remisé</th>
                    <th>Stock Réel</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {selectedProducts.map((p, idx) => (
                    <tr key={p.ref}>
                      <td>{p.imageUrl && <img src={p.imageUrl} alt={p.label} style={{ width: '50px' }} />}</td>
                      <td>{p.ref}</td>
                      <td>{p.label}</td>
                      <td>{p.price_ttc}</td>
                      <td>
                        <input
                          type="number"
                          value={p.discount}
                          onChange={e => handleDiscountChange(idx, parseFloat(e.target.value) || 0)}
                          style={{ width: '80px' }}
                        />
                      </td>
                      <td>{(p.price_ttc * (1 - (p.discount || 0) / 100)).toFixed(2)}</td>
                      <td>{p.stock_reel}</td>
                      <td>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleRemoveProduct(idx)}
                        >
                          &times;
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <button className="btn btn-success" onClick={exportExcel}>Exporter Excel</button>
            </>
          )}
        </>
      )}
    </div>
  );
}

export default Catalog;
